module.exports = __webpack_public_path__ + "static/media/video@2x.4282ccaf.jpg";